// Plays a short completion animation on a task card: a gold burst and a "Done" check, then the card slides out.
// onDone runs when the card has left, so the list can refresh. Runs onDone at once if animations are not available
// or the viewer has asked for reduced motion.
const GOLD = '#D4AF37';

export const celebrateTaskDone = (node, onDone) => {
  const finish = () => { if (onDone) onDone(); };
  const card = (node && node.closest && node.closest('[data-task-card]')) || node;
  const reduceMotion = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!card || reduceMotion || typeof card.animate !== 'function' || typeof document === 'undefined' || !document.body) {
    finish();
    return;
  }
  try {
    const rect = card.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;

    const burst = document.createElement('div');
    burst.style.cssText = `position:fixed;left:${cx}px;top:${cy}px;width:0;height:0;pointer-events:none;z-index:9999;`;
    document.body.appendChild(burst);

    const count = 14;
    for (let i = 0; i < count; i += 1) {
      const angle = (Math.PI * 2 * i) / count;
      const dist = 60 + (i % 3) * 14;
      const dot = document.createElement('span');
      dot.style.cssText = `position:absolute;left:-4px;top:-4px;width:8px;height:8px;border-radius:50%;background:${i % 2 ? GOLD : '#1a1a1a'};`;
      burst.appendChild(dot);
      dot.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: `translate(${Math.cos(angle) * dist}px, ${Math.sin(angle) * dist}px) scale(0.2)`, opacity: 0 },
      ], { duration: 700, easing: 'ease-out' });
    }

    const check = document.createElement('div');
    check.textContent = '✓ Done';
    check.style.cssText = 'position:absolute;left:-40px;top:-14px;width:80px;text-align:center;font:700 15px Roboto, Arial, sans-serif;color:#8C6D1F;';
    burst.appendChild(check);
    check.animate([
      { transform: 'translateY(10px) scale(0.6)', opacity: 0 },
      { transform: 'translateY(-14px) scale(1.1)', opacity: 1, offset: 0.5 },
      { transform: 'translateY(-30px) scale(1)', opacity: 0 },
    ], { duration: 900, easing: 'ease-out' });
    setTimeout(() => burst.remove(), 1000);

    card.style.overflow = 'hidden';
    const leave = card.animate([
      { transform: 'translateX(0)', opacity: 1, maxHeight: `${rect.height}px`, marginTop: '0px', marginBottom: '0px', paddingTop: '0px', paddingBottom: '0px' },
      { transform: 'translateX(60px)', opacity: 0, maxHeight: '0px', marginTop: '0px', marginBottom: '0px', paddingTop: '0px', paddingBottom: '0px' },
    ], { duration: 520, delay: 380, easing: 'ease-in', fill: 'forwards' });
    leave.onfinish = finish;
    leave.oncancel = finish;
  } catch (err) {
    finish();
  }
};
